// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oAMQ5","title":"styles_title__1mj9Q"};